import type { Movie } from '@/types/movie';

export const movies: Movie[] = [
  {
    id: 'deep-sea-echo',
    title: '深海回声',
    category: 'movie',
    year: 2026,
    region: '中国大陆',
    genres: ['科幻', '悬疑'],
    director: '林砚舟',
    actors: ['顾清和', '苏未晞', '江夜白'],
    rating: 8.7,
    heat: 9850,
    duration: '132 分钟',
    releaseDate: '2026-02-14',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20diver%20silhouette%20descending%20through%20deep%20dark%20ocean%20with%20glowing%20blue%20particles%2C%20moody%20atmosphere%2C%20dramatic%20teal%20and%20deep%20navy%20tones%2C%20minimal%20vertical%20composition%2C%20high%20contrast%2C%20elegant%20cinematic%20lighting&width=600&height=900&seq=yaojing-movie-01&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20ocean%20trench%20scene%20with%20a%20submersible%20and%20bioluminescent%20glow%2C%20dark%20teal%20and%20navy%20color%20palette%2C%20atmospheric%20haze%2C%20dramatic%20lighting%2C%20film%20still%20composition&width=1600&height=900&seq=yaojing-banner-01&orientation=landscape',
    synopsis: '一支深海科考队在马里亚纳海沟失联，救援潜水员顾清和独自下潜，却在万米之下听到了本不该存在的回声。随着信号一次次逼近，他发现这段"回声"正指向十年前那场被掩埋的事故。',
    tags: ['深海', '科幻悬疑', '硬核设定', '科考'],
  },
  {
    id: 'light-chaser',
    title: '追光者',
    category: 'movie',
    year: 2025,
    region: '中国大陆',
    genres: ['剧情', '励志'],
    director: '沈亦白',
    actors: ['程野', '柳知夏', '周牧之'],
    rating: 8.4,
    heat: 8320,
    duration: '118 分钟',
    releaseDate: '2025-09-30',
    poster: 'https://readdy.ai/api/search-image?query=Inspirational%20drama%20movie%20poster%20of%20a%20young%20photographer%20standing%20on%20a%20rooftop%20at%20golden%20sunrise%2C%20warm%20amber%20and%20orange%20light%2C%20silhouette%20against%20city%20skyline%2C%20hopeful%20mood%2C%20vertical%20composition%2C%20cinematic%20film%20grain&width=600&height=900&seq=yaojing-movie-02&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Sweeping%20city%20rooftop%20skyline%20at%20golden%20hour%20with%20warm%20sun%20flare%2C%20amber%20and%20honey%20tones%2C%20lens%20flare%2C%20hopeful%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-banner-02&orientation=landscape',
    synopsis: '梦想成为纪录片摄影师的小镇青年程野，带着一台旧相机闯入大城市。在一次次被拒绝与误解之后，他遇见了改变他人生轨迹的一场日出。',
    tags: ['治愈', '小人物', '摄影', '成长'],
  },
  {
    id: 'starlight-city',
    title: '星轨之城',
    category: 'movie',
    year: 2025,
    region: '美国',
    genres: ['科幻', '爱情'],
    director: 'Evan Cole',
    actors: ['顾清和', '艾薇·莱恩', '陈聿'],
    rating: 7.9,
    heat: 7640,
    duration: '145 分钟',
    releaseDate: '2025-07-18',
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20sci-fi%20movie%20poster%20of%20a%20couple%20standing%20beneath%20a%20giant%20planet%20ring%20in%20a%20futuristic%20city%2C%20violet%20and%20warm%20orange%20nebula%20sky%2C%20glowing%20lights%2C%20dreamy%20atmosphere%2C%20vertical%20cinematic%20composition&width=600&height=900&seq=yaojing-movie-03&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Futuristic%20sprawling%20city%20at%20night%20under%20a%20colossal%20ringed%20planet%2C%20deep%20blue%20sky%20with%20warm%20city%20glow%2C%20neon%20and%20amber%20accents%2C%20epic%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-banner-03&orientation=landscape',
    synopsis: '在环绕巨行星运行的人造城市里，导航工程师与一位失忆的天文观测员相遇。城市的轨道正在失稳，而唯一能修复它的人，恰好忘记了关于她的一切。',
    tags: ['太空', '命运', '视觉系', '软科幻'],
  },
  {
    id: 'silent-confession',
    title: '无声告白',
    category: 'movie',
    year: 2024,
    region: '中国香港',
    genres: ['悬疑', '剧情'],
    director: '麦致远',
    actors: ['苏未晞', '郑一鸣', '何嘉仪'],
    rating: 8.1,
    heat: 7010,
    duration: '124 分钟',
    releaseDate: '2024-11-08',
    poster: 'https://readdy.ai/api/search-image?query=Crime%20mystery%20movie%20poster%20of%20a%20shadowed%20figure%20standing%20in%20a%20dimly%20lit%20alley%2C%20rain%20and%20reflections%2C%20cold%20desaturated%20blue-grey%20tones%20with%20one%20warm%20street%20lamp%2C%20tense%20moody%20cinematic%20vertical%20poster&width=600&height=900&seq=yaojing-movie-04&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Rain-soaked%20narrow%20city%20alley%20at%20night%20with%20wet%20cobblestones%20and%20a%20single%20glowing%20street%20lamp%2C%20cold%20slate%20blue%20tones%2C%20tense%20detective%20film%20still&width=1600&height=900&seq=yaojing-banner-04&orientation=landscape',
    synopsis: '一桩没有目击者的坠楼案，一份始终没有被说出口的告白。刑警在追查真相的过程中发现，所有证词都完美得不像真的。',
    tags: ['犯罪', '反转', '港产片', '推理'],
  },
  {
    id: 'dawn-raid',
    title: '破晓行动',
    category: 'movie',
    year: 2026,
    region: '中国大陆',
    genres: ['动作', '战争'],
    director: '高振岳',
    actors: ['江夜白', '程野', '雷震'],
    rating: 7.6,
    heat: 8930,
    duration: '150 分钟',
    releaseDate: '2026-01-01',
    poster: 'https://readdy.ai/api/search-image?query=High-octane%20action%20war%20movie%20poster%20of%20soldiers%20advancing%20through%20smoke%20at%20dawn%2C%20orange%20explosion%20glow%20against%20cool%20blue%20smoke%2C%20dramatic%20backlight%2C%20gritty%20cinematic%20vertical%20composition&width=600&height=900&seq=yaojing-movie-05&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Dramatic%20battlefield%20at%20dawn%20with%20smoke%2C%20distant%20explosions%20and%20warm%20sun%20breaking%20through%20blue%20fog%2C%20epic%20war%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-banner-05&orientation=landscape',
    synopsis: '破晓前的一小时，是整场战役最关键的时刻。一支小分队被派往敌后切断补给线，他们必须在太阳升起前完成不可能完成的任务。',
    tags: ['战争', '热血', '大制作', '群像'],
  },
  {
    id: 'cloud-lovers',
    title: '云端恋人',
    category: 'movie',
    year: 2024,
    region: '韩国',
    genres: ['爱情', '喜剧'],
    director: 'Kim Ha-eun',
    actors: ['柳知夏', '朴叙', '尹昭熙'],
    rating: 7.4,
    heat: 6120,
    duration: '112 分钟',
    releaseDate: '2024-08-20',
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20movie%20poster%20of%20a%20smiling%20couple%20on%20a%20rooftop%20with%20soft%20pastel%20pink%20and%20cream%20sky%2C%20floating%20paper%20planes%2C%20airy%20bright%20tone%2C%20playful%20cinematic%20vertical%20composition&width=600&height=900&seq=yaojing-movie-06&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Bright%20airy%20rooftop%20scene%20with%20soft%20pastel%20sky%20and%20floating%20paper%20planes%2C%20warm%20cream%20and%20pink%20tones%2C%20light%20romantic%20film%20still&width=1600&height=900&seq=yaojing-banner-06&orientation=landscape',
    synopsis: '两个常常在同一班航班上偶遇的陌生人，因为一次误机开始了啼笑皆非的同城之旅。有些距离，飞得再高也绕不过。',
    tags: ['浪漫', '轻喜剧', '都市', '机场'],
  },
  {
    id: 'against-the-wind',
    title: '逆风飞行',
    category: 'movie',
    year: 2023,
    region: '中国大陆',
    genres: ['剧情', '运动'],
    director: '沈亦白',
    actors: ['周牧之', '程野', '梁以宁'],
    rating: 8.0,
    heat: 5480,
    duration: '126 分钟',
    releaseDate: '2023-10-05',
    poster: 'https://readdy.ai/api/search-image?query=Sports%20drama%20movie%20poster%20of%20a%20lone%20cyclist%20racing%20up%20a%20mountain%20road%20at%20sunset%2C%20warm%20amber%20sky%2C%20motion%20blur%2C%20determined%20silhouette%2C%20inspiring%20cinematic%20vertical%20poster&width=600&height=900&seq=yaojing-movie-07&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Winding%20mountain%20road%20at%20sunset%20with%20a%20cyclist%20climbing%2C%20warm%20amber%20and%20gold%20sky%2C%20long%20shadows%2C%20inspiring%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-banner-07&orientation=landscape',
    synopsis: '被伤病击垮的自行车手重回赛道，用一场无人看好的越野赛证明：真正的对手从来不是别人。',
    tags: ['热血', '竞技', '励志', '公路'],
  },
  {
    id: 'station-nine',
    title: '九号观测站',
    category: 'movie',
    year: 2025,
    region: '英国',
    genres: ['科幻', '惊悚'],
    director: 'Oliver Frost',
    actors: ['陈聿', '艾薇·莱恩', '雷震'],
    rating: 7.8,
    heat: 6690,
    duration: '108 分钟',
    releaseDate: '2025-05-12',
    poster: 'https://readdy.ai/api/search-image?query=Isolated%20sci-fi%20thriller%20movie%20poster%20of%20a%20lone%20research%20station%20silhouette%20on%20a%20frozen%20snowfield%20under%20an%20aurora%2C%20cold%20teal%20and%20white%20tones%2C%20eerie%20isolation%2C%20vertical%20cinematic%20composition&width=600&height=900&seq=yaojing-movie-08&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Frozen%20research%20station%20on%20an%20empty%20snowfield%20beneath%20a%20green%20aurora%2C%20cold%20teal%20and%20icy%20white%20palette%2C%20eerie%20sci-fi%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-banner-08&orientation=landscape',
    synopsis: '南极九号观测站连续三周没有回传数据。当救援队抵达时，站内一切正常，唯独少了所有人。',
    tags: ['极地', '惊悚', '烧脑', '孤立'],
  },
  {
    id: 'between-mountain-sea',
    title: '山与海之间',
    category: 'movie',
    year: 2023,
    region: '法国',
    genres: ['剧情', '文艺'],
    director: 'Camille Roux',
    actors: ['柳知夏', '何嘉仪', '梁以宁'],
    rating: 8.3,
    heat: 4120,
    duration: '119 分钟',
    releaseDate: '2023-04-27',
    poster: 'https://readdy.ai/api/search-image?query=Artistic%20arthouse%20movie%20poster%20of%20a%20lone%20woman%20standing%20on%20a%20cliff%20between%20mountains%20and%20sea%2C%20muted%20sage%20green%20and%20warm%20sand%20tones%2C%20soft%20natural%20light%2C%20poetic%20minimal%20vertical%20composition&width=600&height=900&seq=yaojing-movie-09&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Coastal%20cliff%20where%20mountains%20meet%20the%20sea%20at%20soft%20overcast%20light%2C%20muted%20sage%20and%20sand%20palette%2C%20poetic%20arthouse%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-banner-09&orientation=landscape',
    synopsis: '一位画家回到阔别二十年的海边小镇处理母亲的旧宅，却在整理遗物时重新认识了自己。',
    tags: ['文艺', '家庭', '疗愈', '慢节奏'],
  },
  {
    id: 'long-night',
    title: '长夜将明',
    category: 'tv',
    year: 2026,
    region: '中国大陆',
    genres: ['古装', '历史'],
    director: '高振岳',
    actors: ['顾清和', '梁以宁', '江夜白'],
    rating: 8.8,
    heat: 9920,
    duration: '全 40 集',
    releaseDate: '2026-03-01',
    poster: 'https://readdy.ai/api/search-image?query=Epic%20historical%20Chinese%20drama%20poster%20of%20a%20general%20in%20dark%20armor%20against%20a%20crimson%20sunset%2C%20golden%20and%20deep%20red%20palace%20silhouette%2C%20majestic%20cinematic%20vertical%20composition%2C%20dramatic%20lighting&width=600&height=900&seq=yaojing-tv-01&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20city%20silhouette%20under%20a%20crimson%20dusk%20sky%2C%20golden%20light%20on%20palace%20roofs%2C%20epic%20historical%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-tvbanner-01&orientation=landscape',
    synopsis: '朝堂倾覆之际，一位被贬边疆的旧将被召回京城。长夜之下，他要在权谋与忠诚之间，为天下寻一条生路。',
    tags: ['权谋', '史诗', '古装', '群像'],
  },
  {
    id: 'city-within-city',
    title: '城中之城',
    category: 'tv',
    year: 2025,
    region: '中国大陆',
    genres: ['都市', '罪案'],
    director: '麦致远',
    actors: ['苏未晞', '陈聿', '郑一鸣'],
    rating: 8.3,
    heat: 8410,
    duration: '全 32 集',
    releaseDate: '2025-06-15',
    poster: 'https://readdy.ai/api/search-image?query=Modern%20crime%20drama%20poster%20of%20a%20detective%20walking%20through%20a%20neon-lit%20city%20at%20night%2C%20cold%20blue%20tones%20with%20orange%20neon%20accents%2C%20rain%20reflections%2C%20moody%20cinematic%20vertical%20composition&width=600&height=900&seq=yaojing-tv-02&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Neon-lit%20modern%20city%20street%20at%20night%20with%20rain%20reflections%2C%20cool%20blue%20and%20warm%20orange%20neon%2C%20cinematic%20crime%20drama%20wide%20shot&width=1600&height=900&seq=yaojing-tvbanner-02&orientation=landscape',
    synopsis: '金融城的光鲜之下暗流涌动。一名经侦警察在调查一桩看似普通的挪用案时，撕开了整座城市的利益网络。',
    tags: ['经侦', '都市', '社会派', '群像'],
  },
  {
    id: 'spring-letter',
    title: '春日来信',
    category: 'tv',
    year: 2025,
    region: '中国大陆',
    genres: ['都市', '爱情'],
    director: '林砚舟',
    actors: ['柳知夏', '程野', '尹昭熙'],
    rating: 7.7,
    heat: 7290,
    duration: '全 24 集',
    releaseDate: '2025-03-20',
    poster: 'https://readdy.ai/api/search-image?query=Warm%20romance%20drama%20poster%20of%20a%20young%20woman%20holding%20a%20letter%20under%20blooming%20cherry%20blossoms%2C%20soft%20pink%20and%20cream%20pastel%20tones%2C%20sunlit%20gentle%20mood%2C%20vertical%20cinematic%20composition&width=600&height=900&seq=yaojing-tv-03&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Sunlit%20cherry%20blossom%20avenue%20in%20spring%20with%20soft%20pink%20petals%2C%20warm%20cream%20light%2C%20gentle%20romantic%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-tvbanner-03&orientation=landscape',
    synopsis: '一封寄错了地址的信，让两个素未谋面的人开始了长达一年的书信往来。当春天再来，他们终于决定见上一面。',
    tags: ['治愈', '书信', '慢热', '春日'],
  },
  {
    id: 'mountains-rivers',
    title: '山河故人录',
    category: 'tv',
    year: 2024,
    region: '中国大陆',
    genres: ['历史', '古装'],
    director: '沈亦白',
    actors: ['周牧之', '梁以宁', '雷震'],
    rating: 8.5,
    heat: 6870,
    duration: '全 36 集',
    releaseDate: '2024-09-01',
    poster: 'https://readdy.ai/api/search-image?query=Historical%20epic%20drama%20poster%20of%20a%20scholar%20gazing%20at%20misty%20mountains%2C%20ink-wash%20style%20teal%20and%20beige%20palette%2C%20serene%20poetic%20traditional%20Chinese%20painting%20aesthetic%2C%20vertical%20composition&width=600&height=900&seq=yaojing-tv-04&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Misty%20layered%20mountains%20in%20traditional%20Chinese%20ink-wash%20style%2C%20muted%20teal%20and%20beige%20palette%2C%20serene%20poetic%20atmosphere%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-tvbanner-04&orientation=landscape',
    synopsis: '以一册家族史为线索，讲述三代人在乱世与盛世之间的沉浮，于山河之间写下普通人的名字。',
    tags: ['家国', '群像', '年代', '文艺'],
  },
  {
    id: 'mist-archive',
    title: '迷雾档案',
    category: 'tv',
    year: 2026,
    region: '韩国',
    genres: ['悬疑', '罪案'],
    director: 'Kim Ha-eun',
    actors: ['陈聿', '朴叙', '何嘉仪'],
    rating: 8.1,
    heat: 7710,
    duration: '全 20 集',
    releaseDate: '2026-04-10',
    poster: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20thriller%20poster%20of%20a%20detective%20examining%20case%20files%20in%20a%20dim%20room%2C%20cold%20green-grey%20tones%20with%20a%20single%20warm%20desk%20lamp%2C%20tense%20cinematic%20vertical%20composition&width=600&height=900&seq=yaojing-tv-05&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Dim%20archive%20room%20with%20stacks%20of%20case%20files%20and%20a%20single%20warm%20lamp%2C%20cold%20green-grey%20palette%2C%20tense%20detective%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-tvbanner-05&orientation=landscape',
    synopsis: '一份被尘封十二年的旧档案重见天日。当所有线索都指向同一个名字，真相却比迷雾更让人看不清。',
    tags: ['悬疑', '档案', '双线', '推理'],
  },
  {
    id: 'warm-family',
    title: '家有暖阳',
    category: 'tv',
    year: 2024,
    region: '中国大陆',
    genres: ['家庭', '喜剧'],
    director: '高振岳',
    actors: ['苏未晞', '郑一鸣', '尹昭熙'],
    rating: 7.5,
    heat: 5340,
    duration: '全 30 集',
    releaseDate: '2024-05-18',
    poster: 'https://readdy.ai/api/search-image?query=Warm%20family%20comedy%20drama%20poster%20of%20a%20smiling%20multigenerational%20family%20at%20home%2C%20sunny%20yellow%20and%20cream%20palette%2C%20cozy%20lived-in%20living%20room%2C%20joyful%20vertical%20composition&width=600&height=900&seq=yaojing-tv-06&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Cozy%20sunlit%20family%20living%20room%20with%20warm%20yellow%20light%20and%20homey%20details%2C%20cheerful%20family%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-tvbanner-06&orientation=landscape',
    synopsis: '三代同堂的老房子里，每天都在上演鸡飞狗跳又暖意融融的小事。日子再普通，也有属于自己的太阳。',
    tags: ['家庭', '治愈', '生活流', '合家欢'],
  },
  {
    id: 'star-night-concert',
    title: '星夜音乐会',
    category: 'variety',
    year: 2026,
    region: '中国大陆',
    genres: ['音乐', '真人秀'],
    director: '总导演 何一鸣',
    actors: ['柳知夏', '程野', '梁以宁'],
    rating: 8.2,
    heat: 8120,
    duration: '更新至 12 期',
    releaseDate: '2026-05-06',
    poster: 'https://readdy.ai/api/search-image?query=Music%20reality%20show%20poster%20of%20a%20singer%20under%20stage%20spotlights%20with%20glowing%20bokeh%2C%20deep%20indigo%20and%20warm%20gold%20lights%2C%20energetic%20concert%20atmosphere%2C%20vertical%20composition&width=600&height=900&seq=yaojing-var-01&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Concert%20stage%20with%20glowing%20spotlights%20and%20huge%20crowd%20silhouette%2C%20deep%20indigo%20sky%20with%20warm%20golden%20lights%2C%20energetic%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-varbanner-01&orientation=landscape',
    synopsis: '八位不同风格的音乐人相聚山顶舞台，用一整季的时间，把街头的声音带回星夜之下。',
    tags: ['音乐', '现场', '治愈', '实力派'],
  },
  {
    id: 'extreme-camp',
    title: '极限挑战营',
    category: 'variety',
    year: 2025,
    region: '中国大陆',
    genres: ['竞技', '真人秀'],
    director: '总导演 何一鸣',
    actors: ['江夜白', '雷震', '程野'],
    rating: 7.6,
    heat: 7450,
    duration: '更新至 10 期',
    releaseDate: '2025-08-12',
    poster: 'https://readdy.ai/api/search-image?query=Outdoor%20adventure%20competition%20show%20poster%20of%20contestants%20crossing%20a%20rope%20bridge%20in%20mountains%2C%20dynamic%20action%2C%20warm%20sunset%20and%20cool%20blue%20sky%2C%20energetic%20vertical%20composition&width=600&height=900&seq=yaojing-var-02&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Adventure%20mountains%20with%20contestants%20crossing%20a%20rope%20bridge%20at%20sunset%2C%20warm%20orange%20sky%20with%20cool%20blue%20peaks%2C%20dynamic%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-varbanner-02&orientation=landscape',
    synopsis: '来到极限营地的嘉宾必须完成一系列体能与合作挑战，赢家通吃，输家也要笑着翻过最后一座山。',
    tags: ['竞技', '户外', '团队', '爆笑'],
  },
  {
    id: 'midnight-diner-talk',
    title: '深夜食堂说',
    category: 'variety',
    year: 2025,
    region: '中国大陆',
    genres: ['访谈', '生活'],
    director: '总导演 苏晚',
    actors: ['顾清和', '何嘉仪', '梁以宁'],
    rating: 8.4,
    heat: 6020,
    duration: '更新至 16 期',
    releaseDate: '2025-04-02',
    poster: 'https://readdy.ai/api/search-image?query=Late-night%20talk%20show%20poster%20of%20a%20cozy%20small%20restaurant%20counter%20at%20night%20with%20warm%20lantern%20light%2C%20intimate%20amber%20and%20deep%20brown%20tones%2C%20vertical%20cinematic%20composition&width=600&height=900&seq=yaojing-var-03&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Cozy%20late-night%20street%20food%20stall%20with%20warm%20lantern%20glow%2C%20intimate%20amber%20and%20deep%20brown%20tones%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-varbanner-03&orientation=landscape',
    synopsis: '一间只在深夜营业的小食堂，每期请来一位客人，边吃边聊，把那些不好意思说出口的话讲出来。',
    tags: ['访谈', '慢综艺', '治愈', '美食'],
  },
  {
    id: 'stage-king',
    title: '舞台之王',
    category: 'variety',
    year: 2026,
    region: '中国大陆',
    genres: ['音乐', '竞技'],
    director: '总导演 何一鸣',
    actors: ['尹昭熙', '柳知夏', '雷震'],
    rating: 7.9,
    heat: 8640,
    duration: '更新至 8 期',
    releaseDate: '2026-02-28',
    poster: 'https://readdy.ai/api/search-image?query=Singing%20competition%20show%20poster%20of%20a%20performer%20center%20stage%20under%20dramatic%20spotlights%2C%20bold%20gold%20and%20deep%20crimson%20lighting%2C%20powerful%20vertical%20composition&width=600&height=900&seq=yaojing-var-04&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Dramatic%20empty%20stage%20with%20bold%20gold%20and%20crimson%20spotlights%20beams%2C%20theatrical%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-varbanner-04&orientation=landscape',
    synopsis: '每一位站上舞台的歌手，都要用一首歌证明自己。聚光灯下，没有侥幸，只有实力说话。',
    tags: ['竞演', '实力唱将', '直播', '赛制'],
  },
  {
    id: 'wonder-travel-group',
    title: '奇妙旅行团',
    category: 'variety',
    year: 2024,
    region: '中国大陆',
    genres: ['真人秀', '旅行'],
    director: '总导演 苏晚',
    actors: ['程野', '何嘉仪', '郑一鸣'],
    rating: 7.3,
    heat: 5210,
    duration: '更新至 12 期',
    releaseDate: '2024-06-20',
    poster: 'https://readdy.ai/api/search-image?query=Travel%20variety%20show%20poster%20of%20friends%20on%20a%20road%20trip%20with%20a%20camper%20van%20and%20map%2C%20bright%20sunny%20teal%20and%20orange%20tones%2C%20joyful%20energetic%20vertical%20composition&width=600&height=900&seq=yaojing-var-05&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Scenic%20coastal%20road%20trip%20with%20a%20camper%20van%20and%20open%20blue%20sky%2C%20bright%20teal%20sea%20and%20warm%20sand%2C%20joyful%20travel%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-varbanner-05&orientation=landscape',
    synopsis: '五个性格迥异的旅人临时组队，用有限的预算走遍山海小城，一路状况百出也惊喜不断。',
    tags: ['旅行', '穷游', '治愈', '群像'],
  },
  {
    id: 'laugh-at-life',
    title: '笑对人生',
    category: 'variety',
    year: 2025,
    region: '中国大陆',
    genres: ['喜剧', '真人秀'],
    director: '总导演 苏晚',
    actors: ['郑一鸣', '雷震', '尹昭熙'],
    rating: 8.0,
    heat: 6980,
    duration: '更新至 14 期',
    releaseDate: '2025-10-08',
    poster: 'https://readdy.ai/api/search-image?query=Comedy%20variety%20show%20poster%20with%20playful%20stage%20props%20and%20confetti%2C%20bright%20cheerful%20warm%20yellow%20and%20coral%20tones%2C%20fun%20energetic%20vertical%20composition&width=600&height=900&seq=yaojing-var-06&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20comedy%20stage%20with%20colorful%20confetti%20and%20playful%20lighting%2C%20warm%20yellow%20and%20coral%20palette%2C%20fun%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-varbanner-06&orientation=landscape',
    synopsis: '一群喜剧人用即兴小剧场演绎生活里的荒诞日常，把每一次尴尬都变成全场大笑的理由。',
    tags: ['喜剧', '即兴', '解压', '爆笑'],
  },
  {
    id: 'code-of-silence',
    title: '暗码',
    category: 'movie',
    year: 2026,
    region: '中国香港',
    genres: ['悬疑', '动作'],
    director: '麦致远',
    actors: ['江夜白', '苏未晞', '郑一鸣'],
    rating: 7.7,
    heat: 8090,
    duration: '128 分钟',
    releaseDate: '2026-06-06',
    poster: 'https://readdy.ai/api/search-image?query=Tech%20thriller%20movie%20poster%20of%20a%20hacker%20silhouette%20in%20front%20of%20glowing%20code%20screens%2C%20cold%20cyan%20and%20deep%20indigo%20tones%20with%20orange%20accent%2C%20tense%20vertical%20cinematic%20composition&width=600&height=900&seq=yaojing-movie-10&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Dark%20server%20room%20with%20rows%20of%20glowing%20blue%20indicator%20lights%20and%20cables%2C%20cold%20cyan%20and%20indigo%20palette%2C%20tense%20tech%20thriller%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-banner-10&orientation=landscape',
    synopsis: '一名网络安全专家被卷入一场加密勒索案，唯一的线索是一串永远在变化的暗码。而解开它的人，正是案件的起点。',
    tags: ['黑客', '高智商', '反转', '港产片'],
  },
  {
    id: 'parallel-us',
    title: '平行世界里的我们',
    category: 'tv',
    year: 2026,
    region: '中国大陆',
    genres: ['科幻', '爱情'],
    director: '林砚舟',
    actors: ['柳知夏', '顾清和', '尹昭熙'],
    rating: 8.0,
    heat: 7880,
    duration: '全 28 集',
    releaseDate: '2026-01-15',
    poster: 'https://readdy.ai/api/search-image?query=Sci-fi%20romance%20drama%20poster%20of%20two%20silhouettes%20mirrored%20across%20a%20glowing%20portal%2C%20dreamy%20violet%20and%20warm%20orange%20border%2C%20surreal%20atmospheric%20vertical%20composition&width=600&height=900&seq=yaojing-tv-07&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Surreal%20glowing%20portal%20between%20two%20mirrored%20cityscapes%2C%20dreamy%20violet%20and%20warm%20orange%20light%2C%20atmospheric%20cinematic%20wide%20shot&width=1600&height=900&seq=yaojing-tvbanner-07&orientation=landscape',
    synopsis: '一次实验意外让两个平行世界产生交集。在另一个版本的自己面前，他们必须重新选择一次人生的答案。',
    tags: ['平行世界', '宿命', '情感', '烧脑'],
  },
];

export const getMovieById = (id: string): Movie | undefined =>
  movies.find((m) => m.id === id);